import { useEffect } from 'react';

import { superAvailable, useWebsiteModel } from '../../state/website-model.js';
import { Icon } from '../ui/icons.js';

/**
 * The "Super Prisma" switch: Prisma's strongest mode, for accounts whose rank
 * includes it. Nothing else about models is ever shown.
 */
export function SuperPrisma() {
  const choices = useWebsiteModel((s) => s.choices);
  const on = useWebsiteModel((s) => s.superPrisma);
  const load = useWebsiteModel((s) => s.load);
  const setSuper = useWebsiteModel((s) => s.setSuper);

  useEffect(() => {
    void load().catch(() => undefined);
    const timer = window.setInterval(() => void load().catch(() => undefined), 60_000);
    return () => window.clearInterval(timer);
  }, [load]);

  if (!superAvailable(choices)) return null;
  return (
    <button
      type="button"
      className={`super-prisma${on ? ' is-on' : ''}`}
      aria-pressed={on}
      title={on ? 'Super Prisma is on: her strongest mode for big ideas' : 'Turn on Super Prisma for big ideas'}
      onClick={() => setSuper(!on)}
    >
      <Icon name="sparkles" size={13} />
      <span>Super Prisma</span>
    </button>
  );
}
